// extracted by mini-css-extract-plugin
var _1 = "ProfileLabelsWidgetContent-moduleitemsContainer__LHyPs WidgetContentItemsList-moduleitemsContainer__QKSlj";
var _2 = "ProfileLabelsWidgetContent-moduletitleWrapper__PoSEu WidgetContentItemsList-moduletitleWrapper__Wdg5G";
export { _1 as "itemsContainer", _2 as "titleWrapper" }
